import React from "react";
import { ClockCounterClockwise } from "@phosphor-icons/react";

/**
 * UploadHistoryTable — history log at the bottom of Sheets Sync page.
 */
export default function UploadHistoryTable({ logs }) {
  return (
    <div className="border border-border">
      <div className="p-4 border-b border-border bg-secondary/40 flex items-center gap-2">
        <ClockCounterClockwise size={18} weight="bold" />
        <div className="font-bold uppercase tracking-wider text-sm">Riwayat Upload</div>
      </div>
      {logs.length === 0 ? (
        <div className="p-8 text-center text-muted-foreground text-sm">Belum ada riwayat upload.</div>
      ) : (
        <div className="max-h-96 overflow-y-auto">
          <table className="w-full text-xs">
            <thead className="bg-secondary/40 sticky top-0">
              <tr>
                <th className="p-3 text-left overline">Waktu</th>
                <th className="p-3 text-left overline">File</th>
                <th className="p-3 text-left overline">Oleh</th>
                <th className="p-3 text-left overline">Hasil</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => {
                const c = l.counters || l;
                const total = (c.updated || 0) + (c.mismatch || 0) + (c.not_found || 0) + (c.skipped || 0) + (c.already_verified || 0);
                return (
                  <tr key={l.id || l._id} className="border-t border-border">
                    <td className="p-3 font-mono text-[11px]">{new Date(l.finished_at || l.at).toLocaleString("id-ID")}</td>
                    <td className="p-3 font-mono">{l.filename || l.source || "-"}</td>
                    <td className="p-3">{l.triggered_by || l.by || "-"}</td>
                    <td className="p-3 font-mono text-[11px]">
                      <span className="text-emerald-700 font-bold">{c.updated || 0} update</span>
                      {" · "}
                      <span className="text-red-700">{c.mismatch || 0} mismatch</span>
                      {" · "}
                      <span className="text-blue-700">{c.already_verified || 0} verified</span>
                      {" · "}
                      <span className="text-amber-700">{c.not_found || 0} not-found</span>
                      {" · "}
                      <span className="text-muted-foreground">{c.skipped || 0} skip</span>
                      {" ("}
                      {total} total
                      {")"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
